import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=7203bbd8&scoped=true&"
import script from "./insert.vue?vue&type=script&lang=js&"
export * from "./insert.vue?vue&type=script&lang=js&"
import style0 from "./insert.vue?vue&type=style&index=0&id=7203bbd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7203bbd8",
  null
  
)

export default component.exports